const Sheild = ({ size=15, color="#12a87a", ...props }) => (
    <svg
        width={size + 1}    // add +1 to slightly increase width for better visual balance
        height={size}
        viewBox="5 0 20 25"
        fill="none"
        {...props}
    >
        <path
            d="M12 2L4 6V11C4 16.5 7.5 21.5 12 23C16.5 21.5 20 16.5 20 11V6L12 2Z"
            stroke={color}
            strokeWidth="2"
            fill="none"
        />
    </svg>
);

export default Sheild;
